import { Injectable, inject } from '@angular/core';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class ExtendedInformationService {
    private deviceService = inject(DeviceDetectorService);


    private _deviceInfo = {} as DeviceInfo;
    private _deviceType = 'unknown';
    public get deviceInfo(): DeviceInfo {
        return this._deviceInfo;
    }
    public get deviceType() {
        return this._deviceType;
    }

    constructor() {
        this.getDeviceInfor();
    }

    getDeviceInfor() {
        this._deviceInfo = this.deviceService.getDeviceInfo();

        if (this.deviceService.isMobile()) {
            this._deviceType = 'Mobile';
        }
        if (this.deviceService.isDesktop()) {
            this._deviceType = 'Desktop';
        }
        if (this.deviceService.isTablet()) {
            this._deviceType = 'Tablet';
        }
    }

    addCustomHeader(headers) {
        if (environment.enableExtendedInformation && this.deviceInfo) {
            if (this.deviceType) {
                headers['inspekt-device-type'] = this.deviceType;
            }

            if (this.deviceInfo.browser) {
                headers['inspekt-browser'] = this.deviceInfo.browser;
            }

            if (this.deviceInfo.browser_version) {
                headers['inspekt-browser-version'] = this.deviceInfo.browser_version;
            }

            if (this.deviceInfo.os) {
                headers['inspekt-os'] = this.deviceInfo.os;
            }

            if (this.deviceInfo.os_version) {
                headers['inspekt-os-version'] = this.deviceInfo.os_version;
            }

            if (this.deviceInfo.device) {
                headers['inspekt-device'] = this.deviceInfo.device;
            }

            if (this.deviceInfo.userAgent) {
                headers['inspekt-userAgent'] = this.deviceInfo.userAgent;
            }
        }
    }
}
